import React from 'react';
import ReportLayout from 'src/pages/Reports/Common/report/ReportLayout';
import ReportDetails from 'src/pages/Reports/Common/report/ReportDetails';

const FoodandBeveragesReportDetails: React.FC = () => (
  <ReportLayout title="Food and Beverages Report">
    <ReportDetails
      title="Report Details"
      downloadEndpoint="food_beverage/download"
    />
  </ReportLayout>
);

export default FoodandBeveragesReportDetails;
